import { AxiosError } from 'axios';
import api from '../api';

export type Account = {
  userId: string
  avatar: string
  coverImage: string
  displayName: string
  email: string
  token: string
  isSuperUser: boolean
  roles: string[]
  permissionKeys: string[]
  isTenantConnectedToQuickBooks: boolean
  tenantQuickbooksCompanyCountryCode: string
  tenant: {
    id: number
    publicFolderUrl: string
    name: string
    phoneNumber: string
    active: boolean
    reviewWebsiteAddress: string
    maintenanceLaborSKU: string
    projectLaborSKU: string
    enableLaborAdjustedCost: boolean
    defaultQboSalesTaxId?: number
    defaultQboExemptSalesTaxId?: number
    timeZoneId: string
    accountConfigCompleted: boolean
    defaultLunchBreak?: number
    createdUtc: string
    serviceTicketsEnabled: boolean
  }
}

export const defaultAccount = (): Account => ({
  userId: '',
  avatar: '',
  coverImage: '',
  displayName: '',
  email: '',
  token: '',
  isSuperUser: false,
  roles: [],
  permissionKeys: [],
  isTenantConnectedToQuickBooks: false,
  tenantQuickbooksCompanyCountryCode: '',
  tenant: {
    id: 0,
    publicFolderUrl: '',
    name: '',
    phoneNumber: '',
    active: false,
    reviewWebsiteAddress: '',
    maintenanceLaborSKU: '',
    projectLaborSKU: '',
    enableLaborAdjustedCost: false,
    timeZoneId: '',
    accountConfigCompleted: false,
    createdUtc: '',
    serviceTicketsEnabled: true
  }
})

export const getAccount = async (): Promise<Account> => {
  const response = await api.get<Account>('/account');
  return response.data;
}

export type UpdatePasswordRequest = {
  email: string
  oldPassword: string
  newPassword: string
  confirmNewPassword: string
}

export const updatePassword = async (request: UpdatePasswordRequest): Promise<void> => {
  try {
    await api.post('/users/update-password', request)
  } catch (error) {
    const errorMessage = (error as AxiosError).response?.data as string ?? 'Unable to update password'
    throw new Error(errorMessage)
  }
}

export const updateDisplayName = async (displayName: string): Promise<void> => {
  await api.post('/account/update-display-name', { displayName })
}

export const updateAvatar = async (avatar: string): Promise<void> => {
  await api.post('/account/update-avatar', { avatarDataBase64: avatar })
}
